import React from "react";

export default function HelpPane() {
  const style = "";

  return (
    <div
      id="pane_help"
      style={{
        position: "absolute",
        left: "0px",
        top: "0px",
        width: "100%",
        height: "100%",
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingRight: "10px",
      }}
    >
      <style>{style}</style>

      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          borderRadius: "var(--panel-border-radius)",
          boxShadow: "var(--panel-shadow)",
          background: "var(--emptyPanel-background)",
          display: "flex",
          flexDirection: "column",
          padding: "5px",
          overflow: "hidden",
        }}
      >
        <iframe
          src="https://estada.de/inside-help"
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            padding: "0px",
          }}
        />
      </div>
    </div>
  );
}
